import {
  GET_MY_FUNDS_DETAIL,
  UPLOAD_TEAR_SHEET,
  INVESTORS_LIST,
  UPDATE_MONTHLY_RETURN,
  // UPLOAD_FILE_DECK,
  SEARCH_PMRESULT,
  SEARCH_RPRESULT,
  SEARCH_REPORTRESULT,
  GET_FUND_BIO_USER,
} from "./constants";

export const getMyFundDetail = (id) => {
  return {
    type: GET_MY_FUNDS_DETAIL,
    id,
  };
};

export const uploadTearSheet = (payload, onSuccess , onCloseModal) => {
  return {
    type: UPLOAD_TEAR_SHEET,
    payload,
    onSuccess,
    onCloseModal
  };
};

export function getInvestorList(id) {
  return {
    type: INVESTORS_LIST,
    id,
  };
}

export function updateMonthlyReturn(payload) {
  return {
    type: UPDATE_MONTHLY_RETURN,
    payload,
  };
}
export function getPerformanceMetricsSearchResult(payload) {
  return {
    type: SEARCH_PMRESULT,
    payload
  };
}

export function GetRiskReportSearchResult(payload) {
  return {
    type: SEARCH_RPRESULT,
    payload
  };
}
export function RiskReportSearchResultByMonth(payload) {
  return {
    type: SEARCH_REPORTRESULT,
    payload
  };
}
export function getFundBioUsersAction(id) {
  return {
    type: GET_FUND_BIO_USER,
    id
  };
}